import { useContext, useEffect, useState } from "react";
import { isWithinInterval } from "date-fns";
import restService from "../../../restService";
import UserContext from "../../../contexts/UserContext";
import CampaignContext from "../../../contexts/CampaignContext";
import { Link } from "react-router-dom";
import { ModalComponent } from "../../components";
import Pagination from "../../components/Pagination";
import { PulseLoader } from "react-spinners";
import ActivatePromo from "./activatePromo";

const Station = () => {
  const [stations, setStations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [campaign] = useContext(CampaignContext);
  const [searchTerm, setSearchTerm] = useState("");
  const [agents, setAgents] = useState([]);
  const [showActivationModal, setShowActivationModal] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState();

  const [page, setPage] = useState(1);
  const [pageNumberLimit, setPageNumberLimit] = useState(3);
  const [itemsPerPage, setItermsPerPage] = useState(10);
  const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(3);
  const [minPageNumberLimit, setMinPageNumberLimit] = useState(0);
  const [actionMenu, setActionMenu] = useState("");
  const indexOfLastPage = page * itemsPerPage;
  const indexOfFirstPage = indexOfLastPage - itemsPerPage;

  useEffect(() => {
    fetchStations();
  }, [campaign]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const fetchStations = async () => {
    try {
      const {
        data: { code, data },
      } = await restService.Management.getStations(campaign.id);
      fetchAgents();

      setStations(data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const showActionMenu = (index) => {
    document.getElementById(`station-${index}`).classList.toggle("hidden");
    setActionMenu(index);
  };

  const handleDeleteStation = async (id) => {
    try {
      await restService.Management.deleteStation(campaign.id, id);

      fetchStations();
    } catch (error) {
      console.log(error);
    }
  };

  const showActivation = (value) => {
    setShowActivationModal(true);
    setSelectedAgent(value);
  };

  const fetchAgents = async () => {
    try {
      const {
        data: { code, data },
      } = await restService.Management.getAgents(campaign.id);

      setAgents(data);
    } catch (error) {
      console.log(error);
    }
  };

  const totalAgentsPerStation = (stationId) => {
    if (stationId) {
      let totalStationAgents = agents?.filter(
        (agent) => agent?.stationId === stationId
      )?.length;
      return totalStationAgents;
    } else {
      return 0;
    }
  };

  return (
    <div>
      <div className="md:grid md:grid-cols-3 gap-12 my-4 mb-12">
        <div className="border rounded-lg my-4 bg-white py-5 px-6">
          <div>
            <p className="text-[#848484] text-xs py-1">
              Total Number of Station
            </p>
            <p className="text-xl">{stations?.length}</p>
          </div>
        </div>
        <div className="border rounded-lg my-4 bg-white py-5 px-6">
          <div>
            <p className="text-[#848484] text-xs py-1">Active Stations</p>
            <p className="text-xl">{stations?.length}</p>
          </div>
        </div>
        <div className="border rounded-lg my-4 bg-white py-5 px-6">
          <div>
            <p className="text-[#848484] text-xs py-1">Inactive Stations</p>
            <p className="text-xl">0</p>
          </div>
        </div>
      </div>

      <div className="my-4 mt-8">
        <div className="flex md:flex-row flex-col gap-2 md:items-center justify-between">
          <div className="">
            <label className="relative block">
              <span className="sr-only">Search</span>
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.21879 9.21873L6.64941 6.64935"
                    stroke="#848484"
                    strokeMiterlimit="10"
                  />
                  <path
                    d="M4.21875 7.65625C6.11723 7.65625 7.65625 6.11723 7.65625 4.21875C7.65625 2.32027 6.11723 0.78125 4.21875 0.78125C2.32027 0.78125 0.78125 2.32027 0.78125 4.21875C0.78125 6.11723 2.32027 7.65625 4.21875 7.65625Z"
                    stroke="#848484"
                    strokeMiterlimit="10"
                  />
                </svg>
              </span>
              <input
                type="text"
                placeholder="Search"
                onChange={(e) => {
                  // setPage(0);
                  handleSearch(e);
                }}
                className="py-1.5 md:w-auto w-full pl-8 border-none focus:border-none focus:pr-10 focus:outline-none rounded-md bg-[#F4F4F4] "
              />
            </label>
          </div>

          <div className="flex  items-center justify-between">
            {/* <div className="md:mx-6">
              <button
                className="flex items-center border hover:bg-[#F4F4F4] border-gray-400	rounded py-1.5 px-3"
                type="button"
              >
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.25 1.875H0.625"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                    strokeMiterlimit="square"
                  />
                  <path
                    d="M9.37533 1.875H4.79199"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                    strokeMiterlimit="square"
                  />
                  <path
                    d="M3.54199 3.125C4.23235 3.125 4.79199 2.56536 4.79199 1.875C4.79199 1.18464 4.23235 0.625 3.54199 0.625C2.85164 0.625 2.29199 1.18464 2.29199 1.875C2.29199 2.56536 2.85164 3.125 3.54199 3.125Z"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                    strokeMiterlimit="square"
                  />
                  <path
                    d="M9.375 5H8.75"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                    strokeMiterlimit="square"
                  />
                  <path
                    d="M5.20833 5H0.625"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                    strokeMiterlimit="square"
                  />
                  <path
                    d="M6.45801 6.25C7.14836 6.25 7.70801 5.69036 7.70801 5C7.70801 4.30964 7.14836 3.75 6.45801 3.75C5.76765 3.75 5.20801 4.30964 5.20801 5C5.20801 5.69036 5.76765 6.25 6.45801 6.25Z"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                    strokeMiterlimit="square"
                  />
                  <path
                    d="M1.25 8.125H0.625"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                    strokeMiterlimit="square"
                  />
                  <path
                    d="M9.37533 8.125H4.79199"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                    strokeMiterlimit="square"
                  />
                  <path
                    d="M3.54199 9.375C4.23235 9.375 4.79199 8.81536 4.79199 8.125C4.79199 7.43464 4.23235 6.875 3.54199 6.875C2.85164 6.875 2.29199 7.43464 2.29199 8.125C2.29199 8.81536 2.85164 9.375 3.54199 9.375Z"
                    stroke="#24211D"
                    strokeMiterlimit="10"
                    strokeMiterlimit="square"
                  />
                </svg>
                <span className="text-sm px-1">Filter</span>
              </button>
            </div> */}
            <div>
              <Link
                to="/management/add-station"
                className="flex items-center bg-[#3989DD] border text-white rounded-md py-1 px-3
                           hover:border-[#3989DD] hover:bg-[#4891db] "
                type="button"
              >
                + <span className="mx-3 text-sm">Add New Station</span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="flex">
        <div className="align-middle bg-white inline-block w-full">
          <div className="w-full overflow-x-auto">
            <table className="w-full bg-white border-b-lg shadow-sm ">
              <thead className="bg-[#F4F4F4] rounded  py-2">
                <tr>
                  <th className="text-left whitespace-nowrap text-sm text-[#24211D] px-4 py-5 font-normal ">
                    Station
                  </th>
                  <th className="text-left whitespace-nowrap text-sm text-[#24211D] px-4 py-5 font-normal">
                    Zone
                  </th>
                  <th className="text-left whitespace-nowrap text-sm text-[#24211D] px-4 py-5 font-normal">
                    Agents
                  </th>
                  {/* <th className="text-left whitespace-nowrap text-sm text-[#24211D] px-4 py-5 font-normal rounded-l-lg">
                  Phone Number
                </th> */}

                  <th className="text-left whitespace-nowrap text-sm text-[#24211D] px-4 py-5 font-normal ">
                    Status
                  </th>
                  <th className="text-left whitespace-nowrap text-sm text-[#24211D] px-4 py-5 font-normal  rounded-r-lg">
                    {" "}
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody className="text-[#848484]">
                {loading && (
                  <tr className="w-full">
                    <td className="text-center" colSpan="5">
                      <div className="my-8 mx-auto">
                        <PulseLoader color="#FF6A3A" />
                      </div>
                    </td>
                  </tr>
                )}
                {stations?.length === 0 && (
                  <tr className="w-full">
                    <td className="text-center" colSpan="5">
                      <div className="my-8 mx-auto">
                        <img
                          src={require("../../../assets/images/noData.svg")}
                          alt=""
                          className="mx-auto"
                        />
                      </div>
                    </td>
                  </tr>
                )}
                {stations?.length > 0 &&
                  stations
                    ?.filter((item) => {
                      if (searchTerm && isNaN(Number(searchTerm))) {
                        return (
                          item?.location?.toLowerCase()?.includes(searchTerm) ||
                          item?.zone?.toLowerCase()?.includes(searchTerm)
                        );
                      } else if (searchTerm && !isNaN(Number(searchTerm))) {
                        return item?.agentMsisdn?.includes(searchTerm);
                      } else {
                        return item;
                      }
                    })

                    ?.map((value, index) => {
                      return (
                        <tr
                          key={index}
                          className="hover:bg-[#F4F4F4] hover:cursor-pointer focus:bg-[#F4F4F4] focus:cursor-pointer"
                        >
                          <td className="px-4 whitespace-nowrap text-sm text-[#848484] py-6 px-auto">
                            {value?.location}
                          </td>
                          <td className="px-4 whitespace-nowrap text-sm text-[#848484] py-6 pl-4">
                            {value?.zone}
                          </td>

                          <td className="px-4 whitespace-nowrap text-sm text-[#848484] py-6 pl-4">
                            {value?.agents?.length}
                          </td>
                          {/* <td className="px-4 whitespace-nowrap text-sm text-[#848484] py-6 pl-4">
                        {" "}
                        +{value.agentMsisdn}
                      </td> */}

                          <td className="px-4 whitespace-nowrap  py-6 pl-4">
                            {isWithinInterval(new Date(), {
                              start: new Date(value?.activationStartDate),
                              end: new Date(value?.activationEndDate),
                            }) ? (
                              <button className="capitalize bg-green-600 text-white m-1 text-sm px-4 py-1.5 rounded-lg hover:text-green-600 hover:bg-green-100 hover:border-green-600">
                                active
                              </button>
                            ) : (
                              <button className="capitalize bg-amber-600 text-white m-1 text-sm px-4 py-1.5 rounded-lg hover:text-amber-600 hover:bg-amber-100 hover:border-amber-600">
                                inactive
                              </button>
                            )}
                          </td>
                          <td className="px-4 whitespace-nowrap text-sm text-[#848484] py-6 pl-4">
                            <div className="relative inline-block">
                              <button
                                className="bg-[#F4F4F4] hover:bg-white py-2 rounded-lg px-2"
                                data-index={index}
                                id="menu-button"
                                aria-expanded="true"
                                aria-haspopup="true"
                                onClick={() => showActionMenu(index)}
                              >
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M2.5 11.875C3.53553 11.875 4.375 11.0355 4.375 10C4.375 8.96447 3.53553 8.125 2.5 8.125C1.46447 8.125 0.625 8.96447 0.625 10C0.625 11.0355 1.46447 11.875 2.5 11.875Z"
                                    fill="#848484"
                                  />
                                  <path
                                    d="M10 11.875C11.0355 11.875 11.875 11.0355 11.875 10C11.875 8.96447 11.0355 8.125 10 8.125C8.96447 8.125 8.125 8.96447 8.125 10C8.125 11.0355 8.96447 11.875 10 11.875Z"
                                    fill="#848484"
                                  />
                                  <path
                                    d="M17.5 11.875C18.5355 11.875 19.375 11.0355 19.375 10C19.375 8.96447 18.5355 8.125 17.5 8.125C16.4645 8.125 15.625 8.96447 15.625 10C15.625 11.0355 16.4645 11.875 17.5 11.875Z"
                                    fill="#848484"
                                  />
                                </svg>
                              </button>
                              <div
                                id={`station-${index}`}
                                className={`absolute ${
                                  actionMenu !== index && "hidden"
                                } origin-top-right  mt-2 ring-1 ring-black ring-opacity-5 focus:outline-none right-0 z-10 shadow-lg w-50 bg-white rounded-lg`}
                                role="menu"
                                aria-orientation="vertical"
                                aria-labelledby="menu-button"
                                tabIndex="-1"
                              >
                                <div className="my-2 flex flex-col gap-3 px-2 w-56">
                                  <Link
                                    to={`/management/edit-station/${value.stationId}`}
                                    className=" flex align-center text-blue-700 text-sm hover:bg-[#F4F4F4] hover:rounded-lg px-4 py-1 w-full"
                                  >
                                    <span className="mr-2">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-6 w-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="blue"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth="2"
                                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                        />
                                      </svg>
                                    </span>
                                    Edit
                                  </Link>
                                  <button
                                    onClick={() => showActivation(value)}
                                    className="text-green flex align-center text-green-700 text-sm hover:bg-[#F4F4F4] hover:rounded-lg px-4 py-2 w-full"
                                  >
                                    <span className="mr-2">
                                      <svg width={11} height={16} fill="none">
                                        <path
                                          fill="#00C74C"
                                          d="M4.233 3.704c-.581 0-1.058.477-1.058 1.059v7.408h.53V4.763c0-.296.233-.53.528-.53.296 0 .53.234.53.53v5.291h.529V4.763c0-.582-.477-1.059-1.059-1.059Z"
                                        />
                                        <path
                                          fill="#00C74C"
                                          d="M5.821 7.409c-.581 0-1.058.476-1.058 1.058h.529c0-.296.234-.53.529-.53.295 0 .53.234.53.53v2.116h.528V8.467c0-.582-.477-1.058-1.058-1.058Z"
                                        />
                                        <path
                                          fill="#00C74C"
                                          d="M7.408 7.938c-.58 0-1.058.477-1.058 1.058h.53c0-.295.233-.53.528-.53.296 0 .53.235.53.53v2.117h.529V8.996c0-.581-.477-1.058-1.059-1.058Z"
                                        />
                                        <path
                                          fill="#00C74C"
                                          d="M8.996 8.467c-.582 0-1.059.477-1.059 1.058h.53c0-.295.233-.529.529-.529.295 0 .529.234.529.53v5.291c0 .295-.234.529-.53.529v.529c.582 0 1.06-.477 1.06-1.058V9.525c0-.581-.478-1.058-1.06-1.058ZM1.588 8.996a.265.265 0 0 0-.251.348s.25.77.25 1.504V13.759c0 1.167.95 2.116 2.117 2.116h1.059v-.53H3.704a1.578 1.578 0 0 1-1.587-1.587V10.848c0-.55-.097-.995-.18-1.306a1.31 1.31 0 0 1 1.238 1.306h.53c0-1.02-.833-1.852-1.853-1.852h-.264ZM4.295 1.588a2.649 2.649 0 0 0-2.647 2.085 2.648 2.648 0 0 0 1.547 2.993.265.265 0 1 0 .208-.486 2.114 2.114 0 0 1-1.238-2.394 2.114 2.114 0 0 1 2.117-1.668A2.114 2.114 0 0 1 6.321 3.88a2.114 2.114 0 0 1-1.346 2.335.265.265 0 1 0 .185.496 2.649 2.649 0 0 0 1.683-2.92 2.649 2.649 0 0 0-2.548-2.204Z"
                                        />
                                        <path
                                          fill="#00C74C"
                                          d="M4.378.002A4.236 4.236 0 0 0 .002 4.098a4.236 4.236 0 0 0 3.356 4.277.265.265 0 1 0 .11-.517A3.701 3.701 0 0 1 .53 4.115 3.702 3.702 0 0 1 3.701.568a3.701 3.701 0 0 1 4.047 2.497 3.702 3.702 0 0 1-1.747 4.424.264.264 0 1 0 .252.465 4.236 4.236 0 0 0 1.998-5.056A4.238 4.238 0 0 0 4.378.002Z"
                                        />
                                      </svg>
                                    </span>
                                    Activate
                                  </button>
                                  <button
                                    onClick={() => {
                                      handleDeleteStation(value.stationId);
                                    }}
                                    className="text-red flex align-center text-red-700 text-sm hover:bg-[#F4F4F4] hover:rounded-lg px-4 py-1 w-full"
                                  >
                                    <span className="mr-2">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-6 w-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="red"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth="2"
                                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                        />
                                      </svg>
                                    </span>
                                    Delete
                                  </button>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                    .slice(indexOfFirstPage, indexOfLastPage)}
              </tbody>
            </table>
          </div>
          <Pagination
            page={page}
            setPage={setPage}
            pageNumberLimit={pageNumberLimit}
            maxPageNumberLimit={maxPageNumberLimit}
            setMaxPageNumberLimit={setMaxPageNumberLimit}
            minPageNumberLimit={minPageNumberLimit}
            setMinPageNumberLimit={setMinPageNumberLimit}
            data={stations}
            itemsPerPage={itemsPerPage}
          />
        </div>
      </div>

      <ActivatePromo
        value={selectedAgent}
        showModal={showActivationModal}
        onClose={() => setShowActivationModal(false)}
      />
    </div>
  );
};

export default Station;
